@if ($tag()?.color; as tagColor) {
    <i class="fas fa-tag" [style.color]="tagColor"></i>
} @else {
    <i class="fa-thin fa-tag" [style.color]="'#d0d0d0'"></i>
}
